<template>
  <keep-alive>
    <router-view class="content" />
  </keep-alive>
</template>

<script>
export default {
  name: 'Enter',
}
</script>
